const initialOrder = {
    allempnames : [],
    manualattendances: [],
    manualmessages : {}
};

const manualAttendanceReducer = (ma = initialOrder, action) => {
    switch (action.type) {
        case 'GET_MANUAL_ATTENDANCE':
            return {
                ...ma, manualattendances: action.payload.data
            };
        case 'GET_ALL_EMP_NAME':
            return {
                ...ma, allempnames: action.payload.data
            };
        case 'CHANGE_LOGS':
            return {
                ...ma, manualmessages: action.payload.data
            };
            
        default:return ma;

    }
}
export default manualAttendanceReducer;